export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('viewed', {
    mounted (el, binding) {
      const viewedOnce = (binding.modifiers && binding.modifiers.once) || false;
      let afterThreshold = 0.0;
      if (binding.value.afterThreshold) {
        afterThreshold = parseFloat((binding.value.afterThreshold / el.offsetHeight).toFixed(2));
      }
      const { stop } = useIntersectionObserver(el,
        ([{ isIntersecting }], _) => {
          if (isIntersecting) {
            if (binding.value.func) {
              binding.value.func.apply(undefined, binding.value.params || []);
            }
            if (viewedOnce) {
              stop();
            }
          }
        }, {
          rootMargin: `0px 0px ${binding.value?.params[0]?.beforeMargin || 0}px 0px`,
          threshold: afterThreshold
        });
    }
  });
});
